import "@/App.css";
import CanadaTeamMap from "@/components/CanadaTeamMap";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <CanadaTeamMap />
    </div>
  );
}

export default App;
